import api from "@/helpers/api";

export default async ({ commit }, userId) => {
  try {
    const {
      data: { data },
    } = await api.get(`v1/properties/${userId}`);

    if (data) {
      commit("SET_PROPERTIES", data);
    }
  } catch (error) {
    console.error(error);
  }
};
